export default {
  // convert date string from YYY-MM-DD format to DD.MM.YYYY
  prepareDateFromAPI(dateString) {
    if (dateString) {
      const [year, month, day] = dateString.split('-');
      const date = `${day}.${month}.${year}`;
      return date;
    }
    return dateString;
  },
  // convert date string from DD.MM.YYYY format to Date object
  getDateObj(dateString) {
    if (dateString) {
      const [day, month, year] = dateString.split('.');
      const date = new Date(`${year}-${month}-${day}`);
      return date;
    }
    return dateString;
  },
  isValidDate(dateObject) {
    if (dateObject.getTime()) {
      return true;
    }
    return false;
  },
  prepareDateToSend(dateString) {
    if (dateString) {
      const [day, month, year] = dateString.split('.');
      const date = `${year}-${month}-${day}`;
      return date;
    }
    return dateString;
  },
};
